import React, { useEffect, useState } from "react";
import Select from "react-select";

import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveBump } from '@nivo/bump'
import { ResponsiveLine } from '@nivo/line'

import { linearGradientDef } from '@nivo/core'


import "react-awesome-lightbox/build/style.css";
import { Modal, Col } from "react-bootstrap";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import moment from "moment"
/* Styles */
import 'react-multi-carousel/lib/styles.css';
import "../../../../../../styles/app/pages/CampaingPreview.scss";
import "./fix.css"

export function ExecutiveSummaryBar({ raw, total, mainTask, campaign, item: key, length }) {



    const [show, setShow] = useState(false);
    const _raw_base = [...raw].filter(row => row.task === mainTask);
    const data = []
    const pos_options = [...new Set(_raw_base.map(row => row.pos))]

    const col = length === key ? total % 2 !== 0 ? "col-12 p-2" : "col-6 p-2" : "col-6 p-2"
    return (
        <>
            <DetailsModal
                campaign={campaign}
                show={show}
                mainTask={mainTask}
                setShow={setShow}
                raw={_raw_base}
                onHide={() => setShow(false)}
                data={data}
            />
            <div className={col}>
                <div className="card text-center shadow-sm pointer-hover" style={{ height: "200px" }} onClick={() => setShow(true)}>
                    <br />
                    <h4 className="px-4 pt-4"><strong>{mainTask}</strong></h4>
                    <h6>Tendencias precios</h6>

                    <div className="pb-4 text-center" style={{ height: "200px", width: "100%" }}>

                        <i class="fas fa-chart-area fa-8x" style={{ color: "#8330C0" }}></i>
                    </div>

                </div>



            </div>


        </>
    );
}
export function DetailsModal({
    raw,
    show,
    onHide,
    mainTask,
    setShow,

}) {
    // const data_by_product = []


    const [index, setIndex] = useState("pos")
    const [data, setData] = useState([])
    const [pos, setPOS] = useState(null)
    const [product, setProduct] = useState(null)
    const def = { label: "NONE", value: null }
    const pos_options = [...new Set(raw.map(row => row.pos))]
    const product_options = [...new Set(raw.map(row => row.product))]

    const [keys, setKeys] = useState(product_options)


  
    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    useEffect(() => {
        const data_by_pos = []
        product_options
            .filter(option => option === product)
            .forEach(product => {
                const by_product = raw.filter(row => row.product === product).filter(row => row.pos === pos || !pos)
                if(!by_product.length){
                    return;
                }
                const by_dates = by_product.reduce((acc, row) => ({ ...acc, [row.write]: row.quantity + (acc[row.write] ?? 0) }), {})
                const data = Object.entries(by_dates).map(([date, quantity]) => ({
                    "x": date,
                    "y": quantity
                })).sort((a, b) => moment(a.x, "MM/DD/YYYY").toDate() - moment(b.x, "MM/DD/YYYY").toDate())
                const document = {
                    id: product,
                    color: getRandomColor(),
                    data: data

                }
                data_by_pos.push(document)
            })

        setData(data_by_pos)
    }, [pos, product])
    console.log(data)
    const _pos_options = pos_options.filter(() => true)
    const select_pos = [def, ...pos_options.map(key => ({ label: key, value: key }))]
    const select_prd = [def, ...product_options.map(key => ({ label: key, value: key }))]
    return (
        <Modal show={show}
            size="lg"
            closeButton
            dialogClassName="modal-90w"
        >
            <Modal.Header onHide={onHide} closeButton>
                <div className="row d-flex w-100 justify-content-between">
                    <div className="col-10">
                        <h1>Detalle, {mainTask}</h1>
                    </div>
                    <div className="col">
                        <div className="d-flex w-100 justify-content-end">
                            <span className="d-inline pointer-hover" onClick={() => {
                                setShow(false)
                            }}>
                                <i class="fas fa-times fa-2x" style={{ color: "#000" }}></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
                <div className="row p-2">
                <Col xs={12}><h5>*Debes seleccionar algun filtro para poder ver los datos.</h5></Col>
                    <Col xs={3}>
                        <label>Select POS</label>
                        <Select
                            options={select_pos}
                            onChange={(args) => {
                                setPOS(args.value)
                                // setIndex("pos")
                                // setKeys(pos_options)

                            }}
                        />
                    </Col>
                    <Col xs={3}>
                        <label>Select Product</label>
                        <Select
                            options={select_prd}
                            onChange={(args) => {
                                setProduct(args.value)
                                // setIndex("product")
                                // setKeys(product_options)

                            }} />
                    </Col>
                    <Col xs={3}>
                        <br />

                        <button
                            className="btn btn-secondary mt-2"
                            onClick={() => {
                                setPOS(null)
                                setProduct(null)
                                setIndex("pos")
                                setKeys(product_options)

                            }} >
                            Reset
                        </button>
                    </Col>
                </div>


                <div className="pb-4" style={{ height: "600px", width: "100%" }}>

                    <ResponsiveLine
                        data={data}
                        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                        xScale={{ type: 'point' }}
                        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                        yFormat=" >-.2f"
                        curve="monotoneX"
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            orient: 'bottom',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'dates',
                            legendOffset: 36,
                            legendPosition: 'middle'
                        }}
                        axisLeft={{
                            orient: 'left',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'price',
                            legendOffset: -40,
                            legendPosition: 'middle'
                        }}
                        enablePoints={false}
                        pointSize={2}
                        pointColor={{ theme: 'background' }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: 'serieColor' }}
                        enablePointLabel={true}
                        pointLabelYOffset={-12}
                        areaOpacity={0.75}
                        useMesh={true}
                        motionConfig="wobbly"
                    />
                </div>

            </Modal.Body>

        </Modal>
    )
}

